import { Membership } from "../typings/organization";
import { thor, Quota } from "../typings/thor";

export const isAdvertiser = (organization: thor.Organization) => organization.membership === Membership.Advertiser;

export const isMember = (organization: thor.Organization) => organization.membership === Membership.Member;

export const isQuotaConsumed = (yearQuota?: Quota) => !yearQuota || yearQuota.consumed >= yearQuota.quota;
